import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { INfcStickersErrors } from '../../../../models';

class ProductStickersListItem implements ng.IController {
	public static $inject = [];
	public formName: string;
	public itemId: number;
	public stickerNumber: string;
	public backupStickerNumber: string;
	public stickerErrors: INfcStickersErrors[];
	public stickerError: INfcStickersErrors;
	public stickerNumberWasChanged: boolean = false;
	public stores: any[];
	public storesDic: any;
	public pattern = '[A-Z]{1}\\d{12}$';

	public $onInit(): void {
		if (this.stickerNumber) {
			this.backupStickerNumber = this.stickerNumber;
		}

		if (this.itemId) {
			this.formName = 'sticker_' + this.itemId;
		}
	}

	public $onChanges(onChangesObj: angular.IOnChangesObject): void {
		if (onChangesObj.stores && onChangesObj.stores.currentValue) {
			const dict = {};
			this.stores.forEach((store) => { dict[store.ID] = store; });
			this.storesDic = dict;
		}

		if (onChangesObj.stickerErrors && onChangesObj.stickerErrors.currentValue) {
			this.stickerError = this.stickerErrors.filter((r) => r.id === this.itemId)[0];
		}
	}

	public changeStickerNumber = () => {
		if (!this.backupStickerNumber) { return; }
		this.stickerNumberWasChanged = this.stickerNumber !== this.backupStickerNumber;
	}
}

angular.module('naut').component('productStickersListItem', {
	template: require('./product-stickers-list-item.component.html'),
	controller: ProductStickersListItem,
	controllerAs: 'ctrl',
	bindings: {
		itemId: '<',
		stickerNumber: '=',
		selectedStoreId: '=',
		position: '=',
		stores: '<',
		hidePosition: '<',
        isDisabled: '<',
		onDeleteItem: '&',
		stickerErrors: '<'
	}
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-stickers-list/product-stickers-list-item/product-stickers-list-item.component.ts